import { Tooltip } from "@mui/material";
import React from "react";
import { useEffect, useContext } from 'react';

import moment from "moment";
import { useHistory } from 'react-router-dom';
import { groupHolidaysByMonth } from "../Helper/utils";
import { logEventToAnalyticsPlatform } from "../../../helper/events"
import { EVENTS } from "../events_Constant"
import { getUrlForDoctorHolidaysPage } from "../Helper/utils"
import UserFeaturesContext from "../../../hook/UserDetails/UserFeaturesContext";
import { checkFeatureFeasbility } from "../../../helper/utils";
import { FEATURE_NAME } from "../constant";

export const HolidaysDaysCell = ({ holidays, doctorId, providerId }) => {
    const { userFeatures } = useContext(UserFeaturesContext);
    const history = useHistory();
    const doctorHolidayDetails = {
        totalDays: holidays?.length || 0,
        holidayDates: holidays?.map(holiday => holiday?.date),
    };
    const groupedHolidays = groupHolidaysByMonth(holidays);
    const allHolidayRanges = groupedHolidays ? Object.values(groupedHolidays).flat() : [];
    const { totalDays, holidayDates } = doctorHolidayDetails;

    const handleClickOpen = (drId) => {
        logEventToAnalyticsPlatform({
            name: EVENTS.PC_LS_ACTION.name,
            payload: {
                tab_name: EVENTS.TAB_NAME_LC_SCREEN,
                filterValue: '',
                reference_id: '' + drId,
                reference_provider_id: '' + providerId,
                service_name: EVENTS.SERVICE_NAME_OFFLINE_CONSULTS,
                action: EVENTS.ACTION.EDIT_HOLIDAYS_ICON,
            },
            schema: EVENTS.PC_LS_ACTION.schema,
        })
        const url = getUrlForDoctorHolidaysPage(drId);
        history.push(url);
    };
    return (
        <>
            <div className="flex gap-2  items-center w-full">
                <Tooltip
                    title={
                        <React.Fragment>
                            <div className="flex flex-wrap gap-2 p-1 justify-start w-40">
                                {holidayDates.length ?
                                    allHolidayRanges?.map((range, index) => {
                                        return (
                                            <div className="" key={index}>
                                                <div className=' text-normal font-normal'>
                                                    {range.length > 1 ? `${moment(range[0].date).format("MMM Do")} - ${moment(range[range.length - 1].date).format("MMM Do")}` : moment(range[0].date).format("MMM Do")}{index < allHolidayRanges.length - 1 ? "," : null}
                                                </div>
                                            </div>
                                        )
                                    })

                                    : "No Holidays"}
                            </div>
                        </React.Fragment>}
                    placement="bottom">
                    <div className="flex flex-col flex-1">
                        {totalDays > 0 ? (
                            <>
                                <p className=' text-normal font-normal'>
                                    {totalDays} {totalDays > 1 ? "days" : "day"}
                                </p>
                                <p className="text-s text-gray-500 ">
                                    {moment(allHolidayRanges[0][0].date).format("MMM Do")} onwards
                                </p>
                            </>
                        ) :
                            (
                                <p className=' text-normal font-normal'>
                                    ---
                                </p>

                            )}

                    </div>
                </Tooltip>

               { checkFeatureFeasbility(FEATURE_NAME.UPDATE_DOCTOR, userFeatures) && <img src="https://views.medibuddy.in/providerUi/assets/editIcon.svg" alt="Edit" onClick={(e) => { handleClickOpen(doctorId) }} style={{ cursor: 'pointer' }} />}

            </div>
        </>
    )
}
